import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretDown } from '@fortawesome/pro-solid-svg-icons/faCaretDown';
import { faCaretUp } from '@fortawesome/pro-solid-svg-icons/faCaretUp';

import classnames from 'classnames';

import { emptyArray } from 'ui-components/default-props/empty';

import style from './react-table-wrapper.module.less';

/**
 * Renders the header row for a react-table table.
 * @param {object} props
 * @param {() => import('react').HTMLAttributes<HTMLDivElement>} props.getHeaderGroupProps
 * @param {import('../../../prop-types/react-table').ReactTableColumnPropType[]} [props.headers]
 * @param {string} [props.className]
 * @returns {React.ReactElement}
 */
export const ReactTableHeaderRow = ({ getHeaderGroupProps, headers = emptyArray, className }) => {
  const headerGroupProps = getHeaderGroupProps();
  const headerRowClassName = classnames(style['react-table-header-row'], className);

  return (
    <div {...headerGroupProps} className={headerRowClassName}>
      {headers.map((column) => {
        const { isSortable, isSorted, isSortedDesc, getHeaderProps, getSortByToggleProps, render, className: columnClassName } = column;

        const iconClassName = isSorted ? style['sorted-sort-icon'] : style['sort-icon'];
        const icon = isSorted && isSortedDesc ? faCaretDown : faCaretUp;

        const headerCellProps = isSortable ? { ...getHeaderProps(getSortByToggleProps()) } : { ...getHeaderProps() };

        return (
          <div key={headerCellProps.key} className={classnames(style.cell, columnClassName)} {...headerCellProps}>
            {render('Header')}
            {isSortable && <FontAwesomeIcon className={iconClassName} icon={icon} />}
          </div>
        );
      })}
    </div>
  );
};
